export const VARIANT_MODAL_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  MAIN_RECIPE: 'mainRecipe',
};

export const VARIANT_MODAL_WIDTH = '600px';
export const VARIANT_MODAL_CONTENT_PADDING = '24px';
export const VARIANT_MODAL_INPUT_WIDTH = '240px';
export const VARIANT_MODAL_DROPDOWN_WIDTH = '250px';
export const VARIANT_MODAL_DROPDOWN_LIST_MAX_HEIGHT = '200px';
export const VARIANT_MODAL_DROPDOWN_GAP = '32px';
export const VARIANT_MODAL_CONTENT_GAP = '24px';
export const VARIANT_MODAL_LINKED_STORE_ICON_GAP = '6px';
